import React, { useState } from 'react';
import { Box, Typography, Card, CardContent, Tabs, Tab, Paper } from '@mui/material';
import RepInventory from '../../components/rep/RepInventory';
import RepOwnInventory from '../../components/rep/RepOwnInventory';

const InventoryPage = ({ currentUser }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <Box
      sx={{
        pt: { xs: 7, md: 3 },
        minHeight: '100vh',
        maxWidth: '1400px',
        mx: 'auto',
        px: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Typography 
        variant="h4" 
        sx={{ 
          fontWeight: 700, 
          mb: 4, 
          color: '#212121',
          fontFamily: 'Poppins, sans-serif'
        }}
      >
        Inventory
      </Typography>
      
      <Card sx={{ boxShadow: 'none', border: '1px solid #ececef' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs 
            value={activeTab} 
            onChange={(e, newValue) => setActiveTab(newValue)}
            sx={{
              '& .MuiTab-root': {
                textTransform: 'none',
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 500
              }
            }}
          >
            <Tab label="Client Inventory" />
            <Tab label="My Stock" />
          </Tabs>
        </Box>
        <CardContent sx={{ p: { xs: 3, md: 5 } }}>
          {activeTab === 0 && <RepInventory />}
          {activeTab === 1 && <RepOwnInventory />}
        </CardContent>
      </Card>
    </Box>
  );
};

export default InventoryPage;
